/* ===== header.js ===== */
/* ==========================================================================
   header.js — header behaviors
   - Off-canvas drawers (search, user login, cart, mobile menu) via [data-target]
   - Shared overlay + body scroll lock
   - Mobile multi-level navigation (drill-down / back)
   - Sticky header hide-on-scroll-down / show-on-scroll-up
   ========================================================================== */
(function () {
  'use strict';

  function ts(key, vars) {
    return (window.ts || function (k) { return k; })(key, vars);
  }

  const body = document.body;

  /* ---- Shared overlay ---- */
  let overlay = document.querySelector('.site-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'site-overlay';
    body.appendChild(overlay);
  }

  function closeAll() {
    document.querySelectorAll('.openbox-content.is-open').forEach((el) => el.classList.remove('is-open'));
    /* Mobil menü katmanlarını sıfırla — bir sonraki açılışta L1'den başlasın */
    document.querySelectorAll('#mobile-navigation .category-level-2.is-open, #mobile-navigation .category-level-3.is-open')
      .forEach((panel) => panel.classList.remove('is-open'));
    overlay.classList.remove('is-active');
    body.classList.remove('no-scroll');
  }

  function openDrawer(target) {
    const panel = document.querySelector('.' + target);
    if (!panel) return;
    closeAll();
    panel.classList.add('is-open');
    overlay.classList.add('is-active');
    body.classList.add('no-scroll');
    const input = panel.querySelector('input[type="text"], input[type="email"]');
    if (input) setTimeout(() => input.focus(), 200);
  }

  /* Open triggers */
  document.querySelectorAll('.openbox[data-target]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer(btn.getAttribute('data-target'));
    });
  });

  /* Close triggers */
  overlay.addEventListener('click', closeAll);
  document.querySelectorAll('[data-selector="openbox-close"], .drawer-close').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeAll();
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  /* ---- Mobile navigation drill-down (3 katman) ---- */
  const mobileNav = document.querySelector('#mobile-navigation');
  if (mobileNav) {
    mobileNav.querySelectorAll('.has-sub-category > a').forEach((link) => {
      link.addEventListener('click', (e) => {
        const sub = link.parentElement.querySelector(':scope > .category-level-2, :scope > .category-level-3');
        if (sub) {
          e.preventDefault();
          sub.classList.add('is-open');
        }
      });
    });
    mobileNav.querySelectorAll('.mobile-navigation-back a').forEach((back) => {
      back.addEventListener('click', (e) => {
        e.preventDefault();
        const panel = back.closest('.category-level-2, .category-level-3');
        if (panel) panel.classList.remove('is-open');
      });
    });
  }

  /* ---- Desktop mega menü: tek panel + header hover’ı bloklamaz ---- */
  const nav = document.querySelector('#navigation');
  if (nav) {
    const megaItems = Array.from(nav.querySelectorAll('.has-mega-menu'));
    let leaveTimer = null;

    function closeAllMenus(except) {
      megaItems.forEach((item) => {
        if (except && item === except) return;
        item.classList.remove('is-open');
        const t = item.querySelector(':scope > a');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    function openMenu(item) {
      clearTimeout(leaveTimer);
      closeAllMenus(item);
      item.classList.add('is-open');
      const trigger = item.querySelector(':scope > a');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose(item) {
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(() => {
        item.classList.remove('is-open');
        const trigger = item.querySelector(':scope > a');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }, 160);
    }

    megaItems.forEach((item) => {
      const cats = item.querySelectorAll('.mega-menu-cat');
      const panels = item.querySelectorAll('.mega-menu-panel');

      function activate(index) {
        cats.forEach((c, i) => {
          const on = i === index;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach((p, i) => {
          const on = i === index;
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      }

      item.addEventListener('mouseenter', () => openMenu(item));
      item.addEventListener('mouseleave', () => scheduleClose(item));
      item.addEventListener('focusin', () => openMenu(item));
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) scheduleClose(item);
      });

      cats.forEach((cat) => {
        const idx = parseInt(cat.getAttribute('data-mega-index'), 10) || 0;
        cat.addEventListener('mouseenter', () => activate(idx));
        cat.addEventListener('focus', () => activate(idx));
      });
    });

    /* Başka top-level menüye / logo / sağ ikonlara gelince mega kapansın */
    nav.querySelectorAll('.category-level-1 > ul > li:not(.has-mega-menu)').forEach((item) => {
      item.addEventListener('mouseenter', () => closeAllMenus());
      const trigger = item.querySelector(':scope > a');
      if (!trigger) return;
      item.addEventListener('mouseenter', () => trigger.setAttribute('aria-expanded', 'true'));
      item.addEventListener('mouseleave', () => trigger.setAttribute('aria-expanded', 'false'));
    });

    const header = document.getElementById('header');
    if (header) {
      header.querySelectorAll('.logo, .header-right, .search').forEach((el) => {
        el.addEventListener('mouseenter', () => closeAllMenus());
      });
    }
  }

  /* ---- Sticky header: hide on scroll down, show on scroll up ---- */
  let lastScroll = 0;
  window.addEventListener(
    'scroll',
    () => {
      const current = window.pageYOffset;
      if (current <= 0) {
        body.classList.remove('scroll-up');
        return;
      }
      if (current > lastScroll && !body.classList.contains('scroll-down')) {
        body.classList.remove('scroll-up');
        body.classList.add('scroll-down');
      } else if (current < lastScroll && body.classList.contains('scroll-down')) {
        body.classList.remove('scroll-down');
        body.classList.add('scroll-up');
      }
      lastScroll = current;
    },
    { passive: true }
  );

  /* ---- Predictive search (drawer) ---- */
  const predictiveRoot = document.querySelector('[data-predictive-search]');
  if (predictiveRoot) {
    const input = predictiveRoot.querySelector('[data-predictive-input]');
    const resultsEl = predictiveRoot.querySelector('[data-predictive-results]');
    const popularEl = predictiveRoot.querySelector('[data-predictive-popular]');
    const viewAll = predictiveRoot.querySelector('[data-predictive-view-all]');
    const statusEl = predictiveRoot.querySelector('[data-predictive-status]');
    const form = predictiveRoot.querySelector('[data-predictive-form]');
    const searchUrl = (form && form.getAttribute('action')) || '/search';
    let debounceTimer = null;
    let abortCtrl = null;
    let selectedIndex = -1;

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function formatPrice(raw) {
      if (raw == null || raw === '') return '';
      const n = Number(String(raw).replace(/[^\d.]/g, ''));
      if (!Number.isFinite(n)) return String(raw);
      try {
        return (
          new Intl.NumberFormat('tr-TR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(Math.round(n)) + ' TL'
        );
      } catch (_) {
        return Math.round(n) + ' TL';
      }
    }

    function setPopularVisible(show) {
      if (popularEl) popularEl.hidden = !show;
    }

    function clearResults() {
      resultsEl.innerHTML = '';
      resultsEl.hidden = true;
      if (viewAll) viewAll.hidden = true;
      selectedIndex = -1;
    }

    function showIdle() {
      clearResults();
      setPopularVisible(true);
      if (statusEl) statusEl.textContent = '';
    }

    function productImage(product) {
      var url = '';
      if (product.featured_image && product.featured_image.url) url = product.featured_image.url;
      else if (product.image) url = typeof product.image === 'string' ? product.image : product.image.url;
      if (!url) return '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      /* Drawer gizliyken lazy yüklenmeyebilir — eager kullan */
      return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=112';
    }

    function normalizeTr(str) {
      return String(str || '')
        .replace(/İ/g, 'i')
        .replace(/I/g, 'i')
        .toLowerCase()
        .replace(/ı/g, 'i')
        .replace(/ş/g, 's')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c')
        .trim();
    }

    /** Yedek parça mı? product_type / type / başlık (Liquid yedekParcaMi ile uyumlu) */
    function isSparePart(product) {
      var tip = normalizeTr(product.product_type || product.type || '');
      var title = normalizeTr(product.title || '');
      var tags = Array.isArray(product.tags)
        ? product.tags
        : String(product.tags || '').split(',');
      var tagStr = normalizeTr(tags.join(' '));
      if (tagStr.indexOf('parca') >= 0 || tagStr.indexOf('yedek') >= 0) return true;
      if (tip.indexOf('yedek') >= 0 || title.indexOf('yedek') >= 0) return true;
      if (
        tip.indexOf('arac') >= 0 ||
        tip.indexOf('motosiklet') >= 0 ||
        tip.indexOf('bisiklet') >= 0 ||
        tip.indexOf('scooter') >= 0 ||
        tip.indexOf('moped') >= 0 ||
        tip.indexOf('atv') >= 0
      ) {
        return false;
      }
      /* Tip belirsizse kısa model adı (VSX, VT7) ana mamul sayılır; uzun başlık yedek eğilimli */
      var title = String(product.title || '').trim();
      if (title.length <= 12 && title.indexOf(' ') < 0) return false;
      return tip === '' ? true : false;
    }

    function anaRelevance(product, term) {
      var t = normalizeTr(term);
      var title = normalizeTr(product.title);
      if (title === t) return 0;
      if (title.indexOf(t) === 0) return 1;
      if (title.indexOf(t) >= 0) return 2;
      return 3 + Math.min(title.length, 99);
    }

    function groupByProductType(products, term) {
      var ana = [];
      var yedek = [];
      products.forEach(function (p) {
        if (isSparePart(p)) yedek.push(p);
        else ana.push(p);
      });
      ana.sort(function (a, b) {
        return anaRelevance(a, term) - anaRelevance(b, term);
      });
      return { ana: ana, yedek: yedek };
    }

    function productToSuggestItem(p) {
      if (!p) return null;
      var url = p.url || (p.handle ? '/products/' + p.handle : '');
      if (!url) return null;
      var price = p.price;
      if (price != null && typeof price === 'number' && price > 1000) {
        /* /products/{handle}.js fiyatı kuruş cinsinden */
        price = price / 100;
      } else if (p.price_min != null && typeof p.price_min === 'number') {
        price = p.price_min > 1000 ? p.price_min / 100 : p.price_min;
      }
      return {
        id: p.id,
        title: p.title,
        url: url,
        handle: p.handle,
        price: price,
        product_type: p.product_type || p.type || '',
        featured_image: p.featured_image,
        image: p.image || (p.featured_image && (p.featured_image.src || p.featured_image)),
      };
    }

    function mergeUnique(primary, extras) {
      var seen = {};
      var out = [];
      function add(list) {
        (list || []).forEach(function (p) {
          if (!p) return;
          var key = String(p.id || p.handle || p.url || p.title);
          if (seen[key]) return;
          seen[key] = true;
          out.push(p);
        });
      }
      add(primary);
      add(extras);
      return out;
    }

    function renderProductLink(p) {
      var img = productImage(p);
      var price = formatPrice(p.price);
      return (
        '<a class="predictive-search-item" role="option" href="' +
        escapeHtml(p.url) +
        '">' +
        '<span class="predictive-search-item__img">' +
        (img
          ? '<img src="' + escapeHtml(img) + '" alt="" width="56" height="56" loading="eager" decoding="async">'
          : '') +
        '</span>' +
        '<span class="predictive-search-item__body">' +
        '<span class="predictive-search-item__title">' +
        escapeHtml(p.title) +
        '</span>' +
        (price ? '<span class="predictive-search-item__price">' + escapeHtml(price) + '</span>' : '') +
        '</span></a>'
      );
    }

    function renderProducts(products, term) {
      if (!products.length) {
        resultsEl.innerHTML = '<p class="predictive-search-empty">' + ts('searchEmpty') + '</p>';
        resultsEl.hidden = false;
        setPopularVisible(false);
        if (viewAll) {
          viewAll.href = searchUrl + '?type=product&q=' + encodeURIComponent(term);
          viewAll.hidden = false;
        }
        if (statusEl) statusEl.textContent = ts('searchEmptyStatus');
        return;
      }

      var groups = groupByProductType(products, term);
      var html = '';
      if (groups.ana.length) {
        html +=
          '<div class="predictive-search-group" data-group="ana">' +
          '<div class="predictive-search-group__label">' + ts('searchGroupMain') + '</div>' +
          groups.ana.map(renderProductLink).join('') +
          '</div>';
      }
      if (groups.yedek.length) {
        html +=
          '<div class="predictive-search-group" data-group="yedek">' +
          '<div class="predictive-search-group__label">' + ts('searchGroupSpare') + '</div>' +
          groups.yedek.map(renderProductLink).join('') +
          '</div>';
      }
      if (!html) {
        html = products.map(renderProductLink).join('');
      }

      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
      setPopularVisible(false);
      if (viewAll) {
        viewAll.href = searchUrl + '?type=product&q=' + encodeURIComponent(term);
        viewAll.hidden = false;
        viewAll.textContent = ts('searchViewAllFor', { terms: term });
      }
      if (statusEl) {
        statusEl.textContent =
          ts('searchSuggestions', { count: products.length }) +
          (groups.ana.length ? ' · ' + ts('searchSuggestionsMain', { count: groups.ana.length }) : '') +
          (groups.yedek.length ? ' · ' + ts('searchSuggestionsSpare', { count: groups.yedek.length }) : '');
      }
      selectedIndex = -1;
    }

    /** Kısa model aramasında (VSX) handle ile ana mamulü zorla öne al */
    function fetchExactProduct(term, signal) {
      var handle = normalizeTr(term)
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
      if (!handle || handle.length < 2 || handle.length > 24) return Promise.resolve(null);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        signal: signal,
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(productToSuggestItem)
        .catch(function () {
          return null;
        });
    }

    function fetchSuggest(term) {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      var signal = abortCtrl.signal;
      /* Shopify predictive max = 10 */
      var params = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,tag,variants.title,vendor',
      });

      Promise.all([
        fetch(searchUrl + '/suggest.json?' + params.toString(), {
          signal: signal,
          headers: { Accept: 'application/json' },
        }).then(function (r) {
          if (!r.ok) throw new Error('suggest failed');
          return r.json();
        }),
        fetchExactProduct(term, signal),
      ])
        .then(function (pair) {
          var data = pair[0];
          var exact = pair[1];
          var products =
            (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (exact && !isSparePart(exact)) {
            products = mergeUnique([exact], products);
          }
          renderProducts(products, term);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          resultsEl.innerHTML = '<p class="predictive-search-empty">' + ts('searchLoadError') + '</p>';
          resultsEl.hidden = false;
          setPopularVisible(false);
        });
    }

    function onInput() {
      const term = (input.value || '').trim();
      clearTimeout(debounceTimer);
      if (term.length < 2) {
        showIdle();
        return;
      }
      debounceTimer = setTimeout(() => fetchSuggest(term), 220);
    }

    function updateSelection(items) {
      items.forEach((el, i) => el.classList.toggle('is-active', i === selectedIndex));
      if (selectedIndex >= 0 && items[selectedIndex]) {
        items[selectedIndex].scrollIntoView({ block: 'nearest' });
      }
    }

    if (input) {
      input.addEventListener('input', onInput);
      input.addEventListener('keydown', (e) => {
        const items = resultsEl.querySelectorAll('.predictive-search-item');
        if (!items.length) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          selectedIndex = Math.min(selectedIndex + 1, items.length - 1);
          updateSelection(items);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          selectedIndex = Math.max(selectedIndex - 1, -1);
          updateSelection(items);
        } else if (e.key === 'Enter' && selectedIndex >= 0 && items[selectedIndex]) {
          e.preventDefault();
          window.location.href = items[selectedIndex].href;
        }
      });
    }

    /* Drawer açılınca input’a odak + idle durum */
    const searchTrigger = document.querySelector('.search .openbox[data-target="search-content"]');
    if (searchTrigger) {
      searchTrigger.addEventListener('click', () => {
        setTimeout(() => {
          showIdle();
          if (input) input.focus();
        }, 220);
      });
    }
  }
})();


/* ===== sliders.js ===== */
/* ==========================================================================
   sliders.js — lightweight vanilla carousel
   Initializes any [data-slider] element with prev/next + dots + autoplay.
   Markup:
     <div data-slider data-autoplay="5000">
       <div class="slider-track">...slides...</div>
     </div>
   ========================================================================== */
(function () {
  'use strict';

  function initSlider(root) {
    const track = root.querySelector('.slider-track, .entry-slider-track');
    if (!track) return;
    const slides = Array.from(track.children).filter(function (el) {
      return el.nodeType === 1;
    });
    const prev = root.querySelector('.slider-btn-prev');
    const next = root.querySelector('.slider-btn-next');
    if (slides.length <= 1) {
      root.classList.add('is-single');
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    let index = 0;
    const total = slides.length;
    const autoplay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    let timer = null;

    /* Dots */
    let dotsWrap = root.querySelector('.slider-dots');
    if (!dotsWrap) {
      dotsWrap = document.createElement('div');
      dotsWrap.className = 'slider-dots';
      root.appendChild(dotsWrap);
    }
    const dots = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', () => go(i));
      dotsWrap.appendChild(b);
      return b;
    });

    function update() {
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      track.style.transition = 'transform 0.5s ease';
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }
    function go(i) {
      index = (i + total) % total;
      update();
      restart();
    }
    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(() => go(index + 1), autoplay);
    }

    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));

    /* Pause on hover */
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', restart);

    /* Touch swipe */
    let startX = 0;
    track.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
    track.addEventListener(
      'touchend',
      (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      },
      { passive: true }
    );

    update();
    restart();
  }

  document.querySelectorAll('[data-slider]').forEach(initSlider);

  function initProductSlider(root) {
    const track = root.querySelector('[data-drag-scroll], .sale-products-track');
    if (!track) return;
    const prevBtn = root.querySelector('[data-slider-prev]');
    const nextBtn = root.querySelector('[data-slider-next]');

    function cardStep() {
      const card = track.querySelector('.sale-products-slide');
      if (!card) return Math.max(240, track.clientWidth * 0.72);
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 12;
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      const max = track.scrollWidth - track.clientWidth - 4;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = max <= 0 || track.scrollLeft >= max;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      }
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  document.querySelectorAll('[data-product-slider]').forEach(initProductSlider);
})();


/* ===== accordion.js ===== */
/* ==========================================================================
   accordion.js — accessible accordion
   Works for FAQ (.page-sss-accordion), product highlights (.product-accordion),
   and footer menus (.footer-menu-container[data-menu-type="accordion"] on mobile).
   Click a header (h3 / .footer-menu-title) to toggle its panel.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Generic .accordion / .accordion-item ---- */
  document.querySelectorAll('.accordion').forEach((acc) => {
    const single = !acc.classList.contains('multi'); // close siblings by default
    acc.querySelectorAll('.accordion-item').forEach((item) => {
      const head = item.querySelector('h3');
      if (!head) return;
      head.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        if (single) acc.querySelectorAll('.accordion-item').forEach((i) => i.classList.remove('open'));
        item.classList.toggle('open', !isOpen);
      });
    });
  });

  /* ---- Footer menu accordion (mobile only) ---- */
  function setupFooterAccordion() {
    const isMobile = window.matchMedia('(max-width: 767.98px)').matches;
    const menus = document.querySelectorAll('.footer-menu-container[data-menu-type="accordion"] .footer-menu');
    menus.forEach((menu) => {
      const title = menu.querySelector('.footer-menu-title');
      const content = menu.querySelector('.footer-menu-content');
      if (!title || !content) return;

      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', isMobile ? '0' : '-1');
      title.setAttribute('aria-expanded', menu.classList.contains('open') ? 'true' : 'false');

      if (!title.dataset.bound) {
        title.dataset.bound = '1';
        function toggle() {
          if (!window.matchMedia('(max-width: 767.98px)').matches) return;
          const willOpen = !menu.classList.contains('open');
          menus.forEach((other) => {
            other.classList.remove('open');
            const t = other.querySelector('.footer-menu-title');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            menu.classList.add('open');
            title.setAttribute('aria-expanded', 'true');
          }
        }
        title.addEventListener('click', toggle);
        title.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      }

      if (!isMobile) {
        menu.classList.remove('open');
        title.setAttribute('aria-expanded', 'false');
      }
    });
  }
  setupFooterAccordion();
  window.addEventListener('resize', setupFooterAccordion);
})();


/* ===== product.js ===== */
/* ==========================================================================
   product.js — product detail page behaviors
   - Gallery: thumbnail click swaps the main image
   - Lightweight lightbox for gallery images ([data-lightbox])
   - Quantity stepper (if present)
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Gallery thumbnails ---- */
  const slider = document.querySelector('.product-image-slider');
  const thumbs = Array.from(document.querySelectorAll('#product-thumb-image .thumb-item'));
  const items = Array.from(document.querySelectorAll('.product-image-item'));

  function activate(i) {
    items.forEach((it, idx) => it.classList.toggle('is-active', idx === i));
    thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === i));
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', (e) => {
      e.preventDefault();
      activate(i);
    });
  });
  /* Liquid seçili varyantın görselini zaten is-active işaretliyor; burada 0'a
     dönmek ?variant= ile açılan sayfada yanlış rengi gösteriyordu. */
  if (items.length) {
    const preset = items.findIndex((it) => it.classList.contains('is-active'));
    activate(preset < 0 ? 0 : preset);
  }

  /* ---- Lightbox ---- */
  function buildLightbox() {
    const box = document.createElement('div');
    box.className = 'lightbox';
    box.innerHTML =
      '<button class="lightbox-close" aria-label="' + ts('close') + '">&times;</button>' +
      '<button class="lightbox-prev" aria-label="' + ts('prev') + '">&#10094;</button>' +
      '<img alt="">' +
      '<button class="lightbox-next" aria-label="' + ts('next') + '">&#10095;</button>';
    document.body.appendChild(box);
    return box;
  }

  const triggers = Array.from(document.querySelectorAll('[data-lightbox]'));
  if (triggers.length) {
    const box = buildLightbox();
    const img = box.querySelector('img');
    const sources = triggers.map((t) => t.getAttribute('href') || t.dataset.src);
    let current = 0;

    function show(i) {
      current = (i + sources.length) % sources.length;
      img.src = sources[current];
      box.classList.add('is-open');
      document.body.classList.add('no-scroll');
    }
    function hide() {
      box.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }

    triggers.forEach((t, i) =>
      t.addEventListener('click', (e) => {
        e.preventDefault();
        show(i);
      })
    );
    box.querySelector('.lightbox-close').addEventListener('click', hide);
    box.querySelector('.lightbox-prev').addEventListener('click', () => show(current - 1));
    box.querySelector('.lightbox-next').addEventListener('click', () => show(current + 1));
    box.addEventListener('click', (e) => {
      if (e.target === box) hide();
    });
    document.addEventListener('keydown', (e) => {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') hide();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  /* ---- Quantity stepper ---- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
})();


/* ===== collection.js ===== */
/* ==========================================================================
   collection.js — collection page behaviors
   - Mobile filter sidebar (off-canvas) open/close
   - Sort select (client-side reordering of cards by price, demo only)
   - Grid column toggle (2 / 3 / 4 columns)
   - "Stokta olanlar" checkbox filter (demo)
   ========================================================================== */
(function () {
  'use strict';

  const sidebar = document.querySelector('.left-block');

  function overlay() { return document.querySelector('.site-overlay'); }
  function openFilters() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (overlay()) overlay().classList.add('is-active');
    document.body.classList.add('no-scroll');
  }
  function closeFilters() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (overlay()) overlay().classList.remove('is-active');
    document.body.classList.remove('no-scroll');
  }

  /* Open via FİLTRELE button */
  document.querySelectorAll('[data-filter-open]').forEach((btn) =>
    btn.addEventListener('click', function (e) { e.preventDefault(); openFilters(); })
  );
  /* Close via ✕ button */
  document.querySelectorAll('[data-filter-close]').forEach((btn) =>
    btn.addEventListener('click', function (e) { e.preventDefault(); closeFilters(); })
  );
  /* Close via overlay click + Escape */
  if (sidebar) {
    overlay()?.addEventListener('click', closeFilters);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilters(); });
  }

  /* Grid column toggle */
  const grid = document.querySelector('.showcase-container');
  document.querySelectorAll('[data-columns]').forEach((btn) =>
    btn.addEventListener('click', () => {
      const cols = btn.getAttribute('data-columns');
      if (grid) grid.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
      document.querySelectorAll('[data-columns]').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
    })
  );

  /* Sorting (price asc/desc) — works on data-price attribute */
  const sortSelect = document.querySelector('#sortingOption');
  if (sortSelect && grid) {
    sortSelect.addEventListener('change', () => {
      const cards = Array.from(grid.children);
      const v = sortSelect.value;
      cards.sort((a, b) => {
        const pa = parseFloat(a.dataset.price || '0');
        const pb = parseFloat(b.dataset.price || '0');
        if (v === 'price-asc') return pa - pb;
        if (v === 'price-desc') return pb - pa;
        return (parseInt(a.dataset.order, 10) || 0) - (parseInt(b.dataset.order, 10) || 0);
      });
      cards.forEach((c) => grid.appendChild(c));
    });
  }

  /* Combined filtering: in-stock + price ranges */
  const stockOnly = document.querySelector('#stockOnly');
  const priceBoxes = Array.from(document.querySelectorAll('[data-filter-price]'));

  function applyFilters() {
    if (!grid) return;
    const activeRanges = priceBoxes
      .filter((b) => b.checked)
      .map((b) => [parseFloat(b.dataset.min), parseFloat(b.dataset.max)]);
    const cells = Array.from(grid.children);
    cells.forEach((cell) => {
      const card = cell.querySelector('.showcase');
      if (!card) return;
      let show = true;
      if (stockOnly && stockOnly.checked && card.querySelector('.sold-out-label:not([hidden])')) show = false;
      if (show && activeRanges.length) {
        const price = parseFloat(cell.dataset.price || '0');
        show = activeRanges.some(([mn, mx]) => price >= mn && price <= mx);
      }
      cell.hidden = !show;
    });
  }

  if (stockOnly) stockOnly.addEventListener('change', applyFilters);
  priceBoxes.forEach((b) => b.addEventListener('change', applyFilters));
})();


/* ===== main.js ===== */
/* ==========================================================================
   main.js — global entry point
   - Back-to-top button
   - Basic form validation (newsletter, contact, login)
   - Contact page map switching
   - Service points filtering (city / county / service type)
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Back to top ---- */
  const scrollTop = document.querySelector('#scroll-top a');
  if (scrollTop) {
    scrollTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ---- Helpers ---- */
  function markError(field, on) {
    field.classList.toggle('field-error', on);
  }
  function isEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }
  function toast(msg) {
    let t = document.querySelector('.toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    setTimeout(() => t.classList.remove('is-visible'), 3200);
  }

  /* ---- Newsletter ---- */
  document.querySelectorAll('[data-selector="newsletter-form"]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]');
      if (!isEmail(email.value.trim())) {
        markError(email, true);
        toast(ts('newsletterInvalid'));
        return;
      }
      markError(email, false);
      form.reset();
      toast(ts('newsletterThanks'));
    });
  });

  /* ---- Login panel ---- */
  document.querySelectorAll('[data-selector="login-panel"]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = form.querySelector('input[name="email"]');
      const pass = form.querySelector('input[name="pass"]');
      let ok = true;
      if (!isEmail(email.value.trim())) { markError(email, true); ok = false; } else markError(email, false);
      if (!pass.value) { markError(pass, true); ok = false; } else markError(pass, false);
      if (!ok) { toast(ts('loginError')); return; }
      toast(ts('loginOk'));
    });
  });

  /* ---- Generic dynamic form (contact) ---- */
  document.querySelectorAll('[data-selector="dynamic-form"]').forEach((form) => {
    const submit = form.querySelector('[data-selector="dynamic-form-submit-button"]');
    const back = form.querySelector('[data-selector="return-back"]');
    if (back) back.addEventListener('click', () => form.reset());
    if (submit)
      submit.addEventListener('click', () => {
        let ok = true;
        form.querySelectorAll('[data-required="1"]').forEach((field) => {
          const empty = !field.value || !String(field.value).trim();
          markError(field, empty);
          if (empty) ok = false;
        });
        if (!ok) { toast(ts('formRequired')); return; }
        form.reset();
        toast(ts('formSent'));
      });
  });

  /* ---- Contact page: switch embedded map ---- */
  const mapItems = document.querySelectorAll('.maps-item[data-iframe]');
  const mapEmbed = document.querySelector('.maps-embed');
  if (mapItems.length && mapEmbed) {
    mapItems.forEach((item) =>
      item.addEventListener('click', () => {
        mapItems.forEach((i) => i.classList.remove('active'));
        item.classList.add('active');
        mapEmbed.setAttribute('src', item.getAttribute('data-iframe'));
      })
    );
  }

  /* ---- Service / delivery points (JSON + filters) ---- */
  const servicePage = document.querySelector('#service-points');
  if (servicePage) {
    const citySel = servicePage.querySelector('#cities');
    const countySel = servicePage.querySelector('#counties');
    const typeSel = servicePage.querySelector('#service-types');
    const listEl = servicePage.querySelector('[data-service-list]') || servicePage.querySelector('.service-list');
    const empty = servicePage.querySelector('.service-empty');
    const loading = servicePage.querySelector('[data-service-loading]');
    const source = servicePage.getAttribute('data-source');
    const fallback = servicePage.getAttribute('data-fallback');
    const typeLabel = servicePage.getAttribute('data-type-label') || 'Tip';
    const emptyText = servicePage.getAttribute('data-empty-text') || ts('servicesEmpty');
    const listKind = servicePage.getAttribute('data-kind') || '';
    if (empty) empty.textContent = emptyText;

    let points = [];

    function flagOn(v) {
      return v === true || v === 'true' || v === 1 || v === '1';
    }
    function typeOf(p) {
      if (listKind === 'service') return p.servis_tipleri || p.type || '';
      if (listKind === 'dealers') return p.type || '';
      return p.type || p.servis_tipleri || '';
    }

    function foldTr(s) {
      return String(s || '').toLocaleLowerCase('tr');
    }
    function unique(list) {
      const seen = new Map();
      list.filter(Boolean).forEach((raw) => {
        const k = foldTr(raw);
        const prev = seen.get(k);
        if (!prev) {
          seen.set(k, raw);
          return;
        }
        const prevCaps = prev === prev.toLocaleUpperCase('tr');
        const rawCaps = raw === raw.toLocaleUpperCase('tr');
        if (prevCaps && !rawCaps) seen.set(k, raw);
      });
      return Array.from(seen.values()).sort((a, b) => a.localeCompare(b, 'tr'));
    }
    function samePlace(a, b) {
      return foldTr(a) === foldTr(b);
    }
    /** Tip filtresi: tam eşleşme veya "Servis / Yedek" içinde parça eşleşmesi */
    function typeMatch(pointType, selected) {
      if (!selected) return true;
      if (!pointType) return false;
      if (pointType === selected) return true;
      return pointType
        .split(/\s*\/\s*/)
        .map((s) => s.trim())
        .includes(selected);
    }
    function expandTypes(list) {
      const out = new Set();
      list.forEach((t) => {
        if (!t) return;
        String(t)
          .split(/\s*\/\s*/)
          .map((s) => s.trim())
          .filter(Boolean)
          .forEach((p) => out.add(p));
      });
      return Array.from(out).sort((a, b) => a.localeCompare(b, 'tr'));
    }
    function typeDisplay(v) {
      return String(v) === 'FSM' ? ts('servicesFsm') : v;
    }
    function fill(sel, values, placeholder) {
      if (!sel) return;
      sel.innerHTML =
        '<option value="">' +
        placeholder +
        '</option>' +
        values
          .map((v) => '<option value="' + esc(v) + '">' + esc(typeDisplay(v)) + '</option>')
          .join('');
    }
    function esc(s) {
      return String(s || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;');
    }
    function telHref(phone) {
      return String(phone || '').replace(/[\s()\-]/g, '');
    }
    function cardHtml(p) {
      const phone = p.phone || '';
      const maps = p.maps || '';
      return (
        '<div class="service-card" data-city="' +
        esc(p.city) +
        '" data-county="' +
        esc(p.county) +
        '" data-type="' +
        esc(typeOf(p)) +
        '" data-maps="' +
        esc(maps) +
        '">' +
        (typeOf(p) ? '<span class="service-type">' + esc(typeOf(p)) + '</span>' : '') +
        '<h4>' +
        esc(p.name) +
        '</h4>' +
        (p.address ? '<p>' + esc(p.address) + '</p>' : '') +
        '<p>' +
        esc(p.city) +
        (p.county ? ' / ' + esc(p.county) : '') +
        '</p>' +
        (phone ? '<p><a href="tel:' + esc(telHref(phone)) + '">' + esc(phone) + '</a></p>' : '') +
        (maps
          ? '<p><a href="' + esc(maps) + '" target="_blank" rel="noopener">' + ts('servicesDirections') + '</a></p>'
          : '') +
        '</div>'
      );
    }

    function filtered() {
      const city = citySel ? citySel.value : '';
      const county = countySel ? countySel.value : '';
      const type = typeSel ? typeSel.value : '';
      return points.filter(
        (p) =>
          (!city || samePlace(p.city, city)) &&
          (!county || samePlace(p.county, county)) &&
          typeMatch(typeOf(p), type)
      );
    }

    function render() {
      if (!listEl) return;
      const city = citySel ? citySel.value : '';
      // İl seçilmeden tüm listeyi basma (680 kart)
      if (points.length > 40 && !city) {
        listEl.innerHTML = '';
        if (empty) {
          empty.style.display = 'block';
          empty.textContent = ts('servicesPickCity');
        }
        return;
      }
      const rows = filtered();
      listEl.innerHTML = rows.map(cardHtml).join('');
      if (empty) {
        empty.textContent = emptyText;
        empty.style.display = rows.length ? 'none' : 'block';
      }
    }

    function bootFromDomFallback() {
      points = Array.from(servicePage.querySelectorAll('.service-card')).map((c) => ({
        city: c.dataset.city || '',
        county: c.dataset.county || '',
        type: c.dataset.type || '',
        name: (c.querySelector('h4') || {}).textContent || '',
        address: '',
        phone: '',
        maps: '',
      }));
      // Keep existing cards; just wire filters
      const cards = Array.from(servicePage.querySelectorAll('.service-card'));
      function applyDom() {
        const city = citySel ? citySel.value : '';
        const county = countySel ? countySel.value : '';
        const type = typeSel ? typeSel.value : '';
        let visible = 0;
        cards.forEach((c) => {
          const ok =
            (!city || c.dataset.city === city) &&
            (!county || c.dataset.county === county) &&
            (!type || c.dataset.type === type);
          c.style.display = ok ? '' : 'none';
          if (ok) visible++;
        });
        if (empty) empty.style.display = visible ? 'none' : 'block';
      }
      fill(citySel, unique(cards.map((c) => c.dataset.city)), ts('servicesSelectCity'));
      const types = unique(cards.map((c) => c.dataset.type));
      if (typeSel) {
        fill(typeSel, types, ts('servicesSelectType', { label: typeLabel }));
        typeSel.disabled = !types.length;
      }
      if (citySel)
        citySel.addEventListener('change', () => {
          fill(
            countySel,
            unique(cards.filter((c) => c.dataset.city === citySel.value).map((c) => c.dataset.county)),
            ts('servicesSelectDistrict')
          );
          if (countySel) countySel.disabled = !citySel.value;
          applyDom();
        });
      if (countySel) countySel.addEventListener('change', applyDom);
      if (typeSel) typeSel.addEventListener('change', applyDom);
    }

    function bootFromJson(data) {
      const raw = Array.isArray(data) ? data : [];
      points = raw.filter((p) => {
        if (listKind === 'dealers') return flagOn(p.bayi);
        if (listKind === 'service') return flagOn(p.servis);
        return true;
      });
      fill(citySel, unique(points.map((p) => p.city)), ts('servicesSelectCity'));
      const types = expandTypes(points.map((p) => typeOf(p)));
      if (typeSel) {
        const typeGroup = typeSel.closest('.form-group');
        if (types.length <= 1) {
          if (typeGroup) typeGroup.style.display = 'none';
        } else {
          fill(typeSel, types, ts('servicesSelectType', { label: typeLabel }));
          typeSel.disabled = false;
        }
      }
      if (citySel)
        citySel.addEventListener('change', () => {
          fill(
            countySel,
            unique(points.filter((p) => samePlace(p.city, citySel.value)).map((p) => p.county)),
            ts('servicesSelectDistrict')
          );
          if (countySel) countySel.disabled = !citySel.value;
          render();
        });
      if (countySel) countySel.addEventListener('change', render);
      if (typeSel) typeSel.addEventListener('change', render);
      render();
    }

    function loadJson(url) {
      return fetch(url).then((r) => {
        if (!r.ok) throw new Error('veri yüklenemedi');
        return r.json();
      });
    }

    if (source) {
      if (loading) loading.style.display = 'block';
      loadJson(source)
        .catch(() =>
          fallback && fallback !== source ? loadJson(fallback) : Promise.reject()
        )
        .then((data) => {
          if (loading) loading.style.display = 'none';
          bootFromJson(data);
        })
        .catch(() => {
          if (loading) loading.style.display = 'none';
          bootFromDomFallback();
        });
    } else {
      bootFromDomFallback();
    }
  }

  /* ---- Header nav fit: sığmazsa hamburger ---- */
  (function fitHeaderNav() {
    const header = document.getElementById('header');
    const nav = header && header.querySelector('[data-header-nav]');
    const middle = header && header.querySelector('.header-middle');
    if (!header || !nav || !middle) return;

    let ticking = false;
    function measure() {
      ticking = false;
      if (window.innerWidth < 1200) {
        header.classList.add('is-nav-compact');
        return;
      }
      header.classList.remove('is-nav-compact');
      void middle.offsetWidth;
      const ul = nav.querySelector('.category-level-1 > ul');
      if (!ul) return;
      /* overflow:hidden yok; middle genişliği vs menü içeriği */
      const overflow = ul.scrollWidth > middle.clientWidth + 2;
      header.classList.toggle('is-nav-compact', overflow);
    }
    function onResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(measure);
    }
    measure();
    window.addEventListener('resize', onResize, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure).catch(() => {});
    }
  })();

  /* ---- Instagram / YouTube social tabs ---- */
  document.querySelectorAll('[data-social-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-tab-index]');
    const panels = root.querySelectorAll('[data-tab-content]');
    tabs.forEach((tab) => {
      const btn = tab.querySelector('a');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const index = tab.getAttribute('data-tab-index');
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('active', active);
          const a = t.querySelector('a');
          if (a) {
            a.setAttribute('aria-selected', active ? 'true' : 'false');
            a.tabIndex = active ? 0 : -1;
          }
        });
        panels.forEach((panel) => {
          const active = panel.getAttribute('data-tab-content') === index;
          panel.classList.toggle('active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      });
    });
  });

  /* ---- Mark current year in footer copyright if placeholder present ---- */
  document.querySelectorAll('[data-current-year]').forEach((el) => (el.textContent = new Date().getFullYear()));

  /* ---- Product: Paylaş + Karşılaştır (metafield; karşılaştırma motoru yok) ---- */
  document.addEventListener('click', (e) => {
    const shareBtn = e.target.closest('[data-product-share]');
    if (shareBtn) {
      e.preventDefault();
      const url = shareBtn.getAttribute('data-share-url') || window.location.href;
      const title = shareBtn.getAttribute('data-share-title') || document.title;
      if (navigator.share) {
        navigator.share({ title, url }).catch(() => {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => toast(ts('linkCopied'))).catch(() => {
          window.prompt(ts('copyLink'), url);
        });
      } else {
        window.prompt(ts('copyLink'), url);
      }
      return;
    }

    const compareBtn = e.target.closest('[data-product-compare]');
    if (compareBtn) {
      e.preventDefault();
      const text = compareBtn.getAttribute('data-compare-text') || '';
      if (text) toast(text);
    }
  });

  /* ---- Product card variant swatches ----
     Kart tek bir varyantı temsil eder: swatch seçimi görseli, fiyatı, indirim /
     tükendi rozetlerini ve tüm linkleri o varyanta taşır; böylece karttan
     açılan ürün sayfası aynı varyantla geliyor. */
  function cardImg(card) {
    return card ? card.querySelector('.showcase-card-img') : null;
  }
  function setCardImage(img, src) {
    if (!img || !src || img.getAttribute('src') === src) return;
    img.style.opacity = '0.35';
    img.setAttribute('src', src);
    const done = () => { img.style.opacity = '1'; img.removeEventListener('load', done); };
    if (img.complete) img.style.opacity = '1';
    else img.addEventListener('load', done);
  }
  function cardMoney(cents) {
    return (Number(cents || 0) / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 });
  }
  function applyCardSwatch(card, sw) {
    setCardImage(cardImg(card), sw.getAttribute('data-swatch-image'));

    card.querySelectorAll('[data-card-swatch]').forEach((s) => {
      const on = s === sw;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    const url = sw.getAttribute('data-swatch-url');
    if (url) card.querySelectorAll('[data-card-link]').forEach((a) => a.setAttribute('href', url));

    const price = parseInt(sw.getAttribute('data-swatch-price'), 10) || 0;
    const compare = parseInt(sw.getAttribute('data-swatch-compare'), 10) || 0;
    const available = sw.getAttribute('data-swatch-available') !== 'false';
    const onSale = compare > price;

    const cell = card.closest('.showcase-cell');
    if (cell && price) cell.setAttribute('data-price', String(price / 100));

    const priceNew = card.querySelector('[data-card-price-new]');
    if (priceNew && price) {
      priceNew.querySelector('span').textContent = cardMoney(price);
      priceNew.classList.toggle('is-sale', onSale);
    }
    const priceOld = card.querySelector('[data-card-price-old]');
    if (priceOld) {
      priceOld.hidden = !onSale;
      if (onSale) priceOld.querySelector('span').textContent = cardMoney(compare);
    }

    const soldOut = card.querySelector('[data-card-soldout]');
    if (soldOut) soldOut.hidden = available;
    const sale = card.querySelector('[data-card-sale]');
    if (sale) {
      sale.hidden = !(onSale && available);
      const pct = card.querySelector('[data-card-disc]');
      if (pct && onSale) pct.textContent = ts('discountPct', { pct: Math.round(((compare - price) * 100) / compare) });
    }
  }
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-card-swatch]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    const card = sw.closest('[data-product-card]');
    if (card) applyCardSwatch(card, sw);
  });
})();
